var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticStyle: { margin: "20px" },
              attrs: { icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  return _vm.updataApp()
                }
              }
            },
            [_vm._v("\n      新增版本\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.list } },
        [
          _c("el-table-column", { attrs: { label: "编号", type: "index" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "version", label: "版本号" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "platform", label: "平台类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "type", label: "版本类型" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "url", label: "版本链接" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "descrbe", label: "版本描述" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.changeform(row)
                              }
                            }
                          },
                          [_vm._v(" 修改 ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toDelete(row)
                              }
                            }
                          },
                          [_vm._v(" 删除 ")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.ifsee, title: "版本" },
          on: {
            "update:visible": function($event) {
              _vm.ifsee = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px", model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "版本号" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.version,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "version", $$v)
                      },
                      expression: "form.version"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "平台类型" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.platform,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "platform", $$v)
                        },
                        expression: "form.platform"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "iPhone", label: "iPhone" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "HUAWEI", label: "HUAWEI" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "Xiaomi", label: "Xiaomi" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "OPPO", label: "OPPO" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "vivo", label: "vivo" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本类型" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "1", label: "热更新" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "2", label: "版本更新" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本链接" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.url,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "url", $$v)
                      },
                      expression: "form.url"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本描述" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.descrbe,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "descrbe", $$v)
                      },
                      expression: "form.descrbe"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ifsee = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.setUpdataApp()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.ifdelete, title: "版本删除" },
          on: {
            "update:visible": function($event) {
              _vm.ifdelete = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ifdelete = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.deleteApp()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("猩号app版本更新")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d32c575", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d32c575","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/UpDataApp.vue
// module id = null
// module chunks = 